import { Stage } from "@/types/productTypes";
import fetchDb from "@/utils/customRequestFunction";

const base = "/api/stages";

export const stageService = {
   getList: (productId: number) =>
      fetchDb.get<Stage[]>(`${base}/product/${productId}`),

   create: (data: Omit<Stage, "id" | "options">) =>
      fetchDb.post<Stage>(base, data),

   remove: (stageId: number) => fetchDb.delete<void>(`${base}/${stageId}`),

   reorder: (id1: number, id2: number) =>
      fetchDb.patch<void>(`${base}/reorder/${id1}/${id2}`),
};
